import _extends from "@babel/runtime/helpers/esm/extends";
var HTML_FONT_SIZE = 16;
var figtreeFontFamily = "'Figtree', sans-serif";
export var fontWeight = {
  regular: 400,
  medium: 500,
  semiBold: 600
};
export var fontSize = {
  h1: 30,
  h2: 24,
  h3: 18,
  h4: 16,
  h5: 14,
  h7: 12,
  h8: 10
};
var HEADING = {
  h1: {
    desktop: {
      fontSize: 30,
      lineHeight: 1.15
    },
    mobile: {
      fontSize: 24,
      lineHeight: 1.35
    }
  },
  h2: {
    desktop: {
      fontSize: 24,
      lineHeight: 1.35
    },
    mobile: {
      fontSize: 20,
      lineHeight: 1.2
    }
  },
  h3: {
    desktop: {
      fontSize: 20,
      lineHeight: 1.2
    },
    mobile: {
      fontSize: 18,
      lineHeight: 1.35
    }
  },
  h4: {
    desktop: {
      fontSize: 18,
      lineHeight: 1.35
    },
    mobile: {
      fontSize: 18,
      lineHeight: 1.35
    }
  }
};
var TEXT = {
  sm: {
    fontSize: 12,
    lineHeight: 1.5
  },
  base: {
    fontSize: 14,
    lineHeight: 1.45
  },
  lg: {
    fontSize: 16,
    lineHeight: 1.5
  },
  xl: {
    fontSize: 18,
    lineHeight: 1.5
  }
};
export var fontStyle = {
  normal: 'normal',
  italic: 'italic'
};

var pxToRem = function pxToRem(size) {
  return "".concat(size / HTML_FONT_SIZE, "rem");
};

var buildVariant = function buildVariant(weight, size, lineHeight, letterSpacing) {
  return _extends({
    fontFamily: figtreeFontFamily
  }, weight && {
    fontWeight: weight
  }, {
    fontSize: pxToRem(size),
    letterSpacing: letterSpacing,
    lineHeight: lineHeight
  });
};

var variants = {
  h1: buildVariant(fontWeight.medium, fontSize.h1, 1.13, 'normal'),
  h2: buildVariant(fontWeight.medium, fontSize.h2, 1.25, 'normal'),
  h3: buildVariant(fontWeight.semiBold, fontSize.h3, 1.11, 'normal'),
  h4: buildVariant(fontWeight.regular, fontSize.h4, 1.25, 'normal'),
  h5: buildVariant(fontWeight.regular, fontSize.h5, 1.29, 'normal'),
  h6: buildVariant(fontWeight.semiBold, fontSize.h5, 1.29, 'normal'),
  h7: buildVariant(fontWeight.regular, fontSize.h7, 1.5, 'normal'),
  h8: buildVariant(fontWeight.regular, fontSize.h8, 1.5, 'normal'),
  // deprecated
  running: buildVariant(fontWeight.regular, fontSize.h5, 1.43, 'normal'),
  // deprecated
  secondary: buildVariant(fontWeight.regular, fontSize.h5, 1.29, -0.22)
};

var headingVariant = function headingVariant(element) {
  var desktop = buildVariant(fontWeight.semiBold, HEADING[element].desktop.fontSize, HEADING[element].desktop.lineHeight, 'normal');
  var mobile = buildVariant(fontWeight.semiBold, HEADING[element].mobile.fontSize, HEADING[element].mobile.lineHeight, 'normal');
  return {
    desktop: desktop,
    mobile: mobile
  };
};

var headingVariants = {
  h1: headingVariant('h1'),
  h2: headingVariant('h2'),
  h3: headingVariant('h3'),
  h4: headingVariant('h4')
};
var textVariants = {
  sm: buildVariant(null, TEXT.sm.fontSize, TEXT.sm.lineHeight, 'normal'),
  base: buildVariant(null, TEXT.base.fontSize, TEXT.base.lineHeight, 'normal'),
  lg: buildVariant(null, TEXT.lg.fontSize, TEXT.lg.lineHeight, 'normal'),
  xl: buildVariant(null, TEXT.xl.fontSize, TEXT.xl.lineHeight, 'normal')
};
export default _extends({
  htmlFontSize: HTML_FONT_SIZE
}, variants, textVariants, {
  heading: headingVariants,
  fontWeight: fontWeight,
  fontSize: fontSize,
  fontStyle: fontStyle
});